
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/ncaa-picks-and-predictions",
      function () {
        return require("private-next-pages/blog/ncaa-picks-and-predictions.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/ncaa-picks-and-predictions"])
      });
    }
  